import { render } from "./P045.vue?vue&type=template&id=40c691f8&scoped=true"
import script from "./P045.vue?vue&type=script&lang=js"
export * from "./P045.vue?vue&type=script&lang=js"

import "./P045.vue?vue&type=style&index=0&id=40c691f8&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c691f8"]])

export default __exports__